import { useGetCoursesQuery } from "./coursesApiSlice"
import Course from "./Course"
import useAuth from "../../hooks/useAuth"
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link,  useParams } from "react-router-dom"

const CoursesList = () => {
    useTitle('techCourses: Courses List')
    const {groupId, type} = useParams()
     const { username, isManager, isAdmin } = useAuth()

    const {
        data: courses,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetCoursesQuery('coursesList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const { ids, entities } = courses

            const tableContent = ids.map(courseId => <Course key={courseId} courseId={courseId} />)

        content = (
            <>
                    <Link to={`/${type}/${groupId}/courses/new`}>
 <FontAwesomeIcon icon={faAdd} />הוספת קורס
        </Link>
        <table className="table table--courses">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th course__name">Name</th>
                        <th scope="col" className="table__th course__active">Active</th>
                        <th scope="col" className="table__th course__edit">Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
          
        )
    }

    return content
}
export default CoursesList